// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3n1x4","consentsList":"PatientConsents_consentsList__Wofqi","consentsListEmpty":"PatientConsents_consentsListEmpty__2bowZ"};